module.exports = __webpack_public_path__ + "img/背景图.2f7973b9.jpg";